export const DARK_THEME_CLASS = 'dark-theme';
//# sourceMappingURL=constant.js.map